module.exports = __webpack_public_path__ + "img/Fourier2.359748fd.gif";